<template>
    <div class="grid-frame">
        <div class="room-plan" :class="`front-${shownFront}`">
            <div v-if="shownFront !== 'none'" class="front-marker"><span>Tafel</span></div>
            <div class="grid" :style="gridStyle">
                <template v-for="table in shownTables" :key="'table' + table.index">
                    <slot :table="table"></slot>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
// The room as the class sees it: the board on its wall and one field per table. What a field shows comes from the slot.
export default {
    name: 'RoomPlan',
    props: {
        config: Object,
        mirrored: Boolean,
    },
    computed: {
        gridStyle() {
            return {
                '--cols': this.config.cols,
                '--rows': this.config.rows,
            }
        },
        shownTables() {
            return this.mirrored ? this.config.tables.slice().reverse() : this.config.tables
        },
        // The board turns with the room when the view is mirrored
        shownFront() {
            const opposite = { top: 'bottom', bottom: 'top', left: 'right', right: 'left', none: 'none' }
            return this.mirrored ? opposite[this.config.front] : this.config.front
        },
    },
}
</script>

<style scoped>
.grid-frame {
    padding: var(--s-3);
    border: var(--line);
    border-radius: var(--r-control);
    background: var(--hue-wash, var(--ground-wash));
    overflow-x: auto;
}

.room-plan {
    display: flex;
    flex-direction: column;
    gap: var(--s-2);
}

.room-plan.front-bottom {
    flex-direction: column-reverse;
}

.room-plan.front-left {
    flex-direction: row;
}

.room-plan.front-right {
    flex-direction: row-reverse;
}

/* The board on the wall: an ink bar along the side the class looks at */
.front-marker {
    flex: none;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60%;
    height: 22px;
    border-radius: 6px;
    background: var(--ink);
    color: var(--paper);
    font-size: var(--t-xs);
    font-weight: 800;
    letter-spacing: 0.01em;
}

.front-left .front-marker,
.front-right .front-marker {
    width: 22px;
    height: 60%;
}

.front-left .front-marker span,
.front-right .front-marker span {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
}

.front-right .front-marker span {
    transform: none;
}

/* Fills the window's height on a desktop, and never squeezes a table below a readable size. */
.grid {
    display: grid;
    gap: 6px;
    grid-template-columns: repeat(var(--cols), minmax(0, 1fr));
    grid-template-rows: repeat(var(--rows), minmax(0, 1fr));
    flex: 1 1 auto;
    min-width: calc(var(--cols) * 60px);
    height: clamp(calc(var(--rows) * 46px), calc(100vh - 530px), calc(var(--rows) * 84px));
}

@media (max-width: 599px) {
    .grid-frame {
        padding: var(--s-2);
    }
}

@media print {
    .grid-frame {
        overflow: visible;
        background: transparent;
    }

    .grid {
        min-width: 0;
        height: calc(var(--rows) * 15mm);
    }
}
</style>
